<!-- Usage:
<FetchData url="https://wttr.in/Sudbury?format=j1" v-slot:default="{ response, loading }">
    <div v-if="!loading">
        {{response.current_condition[0].FeelsLikeC}}
    </div>
</FetchData>
-->
<script>
export default {
  props: {
    url: {
      type: String,
      default: null
    },
    fetch: {
      type: Function,
      default: null
    }
  },
  data () {
      return {
          loaded: true,
          response: null
      }
  },

  watch: {
    url: {
      imediate: true,
      async handler() {
        if (this.url) {
          this.loaded = false
          const res = await this.axios.get(this.url)
          this.response = res.data, this.loaded = true
        }
      }
    },

    fetch: {
      imediate: true,
      async handler() {
        if (this.fetch) {
          this.loaded = false
          await this.fetch()
          this.loaded = true
        }
      }
    }
  },

  render () {
    return this.$scopedSlots.default({
      loading: !this.loaded,
      response: this.response
    })
  }
}
</script>
